// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"102":"forTranslators","188":"translatorPage","238":"findTranslator"}[chunkId] + "." + {"102":"e2ff3ccc","188":"6c2e77ea","238":"81dffc8f"}[chunkId] + ".css";
};